import { format } from 'date-fns-tz';

export const formatTimeWithTimeZone = (
  date: Date | number,
  timeZone?: string
) => {
  return format(date, "yyyy-MM-dd'T'HH:mm:ssXXX", {
    timeZone
  });
};
